// src/components/LoadingScreen.jsx
import React from 'react';

export const LoadingScreen = ({ message = 'กำลังโหลด...', progress }) => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-dot"></div>
        </div>
        <h3>{message}</h3>
        {progress !== undefined && (
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
        )}
        <p>กรุณารอสักครู่...</p>
      </div>
    </div>
  );
};
